export enum Authority {
  AIR_VISIBILITY = 'AIR_VISIBILITY',
  LTL_VISIBILITY_UI = 'LTL_VISIBILITY_UI',
  OCEAN_VISIBILITY_UI = 'OCEAN_VISIBILITY_UI',
  ORDER_VISIBILITY_UI = 'ORDER_VISIBILITY_UI',
  PARCEL_VISIBILITY_UI = 'PARCEL_VISIBILITY_UI',
  PERM_FLET_LMTD = 'PERM_FLET_LMTD',
  PORTAL_LTL_RATE_QUERY = 'PORTAL_LTL_RATE_QUERY',
  PORTAL_VLTL_RATE_QUERY = 'PORTAL_VLTL_RATE_QUERY',
  RAIL_VISIBILITY_API = 'RAIL_VISIBILITY_API',
  ROLE_P44ADMIN = 'ROLE_P44ADMIN',
  AUTHORIZATION_ADMIN = 'AUTHORIZATION_ADMIN',
  SAVE_USER_ROLES = 'SAVE_USER_ROLES',
  SLOT_BOOKING_SUPPLYSTACK = 'SLOT_BOOKING_SUPPLYSTACK',
  TL_VISIBILITY_API = 'TL_VISIBILITY_API',
  TL_VISIBILITY_UI = 'TL_VISIBILITY_UI',
  VIEW_OCEAN_INSIGHTS_CSS = 'VIEW_OCEAN_INSIGHTS_CSS',
  VIEW_OCEAN_INSIGHTS_CTT = 'VIEW_OCEAN_INSIGHTS_CTT',
  VIEW_OCEAN_REPORTS = 'VIEW_OCEAN_REPORTS',
  VIEW_PORT_INTEL = 'VIEW_PORT_INTEL', // Remove as part of AMI-1289
  VIEW_REPORTS = 'VIEW_REPORTS',
  VIEW_USER_ROLES = 'VIEW_USER_ROLES',
  VIEW_VOC2_ANALYTICS_HOME = 'VIEW_VOC2_ANALYTICS_HOME', // Remove as part of AMI-1289
  VIEW_VOC2_ANALAYTICS_HOME = 'VIEW_VOC2_ANALAYTICS_HOME', // Remove as part of AMI-1289
  VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD = 'VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD', // Remove as part of AMI-1289

  // Analytics permissions
  ANALYTICS_OCEAN_SUSTAINABILITY = 'VIEW_OCEAN_SUSTAINABILITY',
  ANALTYICS_ROOT_CAUSE_ANALYSIS = 'VIEW_TL_TRACKING_REPORT',
  ANALYTICS_PORT_INTEL = 'VIEW_PORT_INTEL',
  ANALYTICS_OCEAN = 'VIEW_VOC2_OCEAN_ANALYTICS_DASHBOARD',
  ANALYTICS_TRUCKLOAD = 'read:truckload_analytics',
  ANALYTICS_VOC_USERS = 'VIEW_REPORTS', // Special permission based on product users coming from VOC

  // P44OS permissions
  P44OS_CONSUMPTION_TRENDS = 'system-admin:read:data-hub-consumption-trends-dashboard',
  P44OS_CUSTOMER_CONSUMPTION = 'system-admin:read:data-hub-customer-consumption-dashboard',
  P44OS_SCORECARD = 'system-admin:read:data-hub-carrier-scorecard-dashboard',
  P44OS_NEWSLETTER = 'system-admin:read:data-hub-carrier-newsletter-dashboard',
  P44OS_CONSUMPTION_TRENDS_ALL_TENANTS = 'system-admin:read:data-hub-consumption-trends-dashboard-all-tenants',
  P44OS_CUSTOMER_CONSUMPTION_ALL_TENANTS = 'system-admin:read:data-hub-customer-consumption-dashboard-all-tenants',
  P44OS_SCORECARD_ALL_TENANTS = 'system-admin:read:data-hub-carrier-scorecard-dashboard-all-tenants',
  P44OS_NEWSLETTER_ALL_TENANTS = 'system-admin:read:data-hub-carrier-newsletter-dashboard-all-tenants',

  // Initiate permissions
  INITIATE_CREATE_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',
  INITIATE_READ_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',
  INITIATE_UPDATE_RATED_SHIPMENTS = 'create:truckload-rated-shipments-and-quotes',

  // Network permissions
  NETWORK_READ_CARRIER_MANAGEMENT = 'read:internal-carrier-identifiers',
  NETWORK_READ_HEALTH_DASHBOARD = 'read:network-health-tl-dashboards',
}
